

<template>
    <li class="list-group-item" v-bind:class="{'story': isStory()}">
        <div class="d-flex align-items-center">
            <button v-show="!isStory() && sending" type="button" class="btn btn-sm me-2" :class="send === true ? 'btn-primary' : 'btn-light'" @click="send = !send">
                <i class="far fa-fw" v-bind:class="{'fa-check': send === true}"></i>
            </button>

            <span class="flex-grow-1" v-show="!edit">{{requirement.title}}</span>
            <input class="form-control form-control-sm flex-grow-1" v-model="requirement.title" v-show="edit">

            <button type="button" class="btn btn-sm btn-link text-muted" v-show="!edit" v-on:click="edit = true"><i class="far fa-pencil"></i></button>
            <button type="button" class="btn btn-sm btn-link text-danger" v-show="!edit" v-on:click="onDelete"><i class="far fa-trash"></i></button>
            <button type="button" class="btn btn-sm btn-primary ms-2" v-show="edit" v-on:click="onSave"><i class="far fa-save"></i></button>
        </div>

        <p class="description mb-0" v-show="edit">
            <textarea class="form-control" v-model="requirement.description"></textarea>
        </p>
    </li>
</template>

<script>
    
    export default {
    	props: ['requirement', 'sending'],
        data: function () {
            return {
                loading: true,
                content: "",
                edit: false,
            	send: false
            }
        },
        mounted: function() {
            var that = this;
        },
        methods: {

        	isStory: function() {
        		return this.requirement.story_id;
        	},

            onSave: function() {
            	var that = this;

            	client({path: '/user-story-document/'+this.$parent.project.user_story_document_id+'/requirements/'+this.requirement.id, entity: this.requirement, method: 'PUT'}).then(
                    function(response) {
                    	that.edit = false;
                    },
                    function(response) {
                        
                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];
                            
                        } else {
                            
                        }
                    }
                )
            },
            onDelete: function() {
                var that = this

            	client({path: '/user-story-document/'+this.$parent.project.user_story_document_id+'/requirements/'+this.requirement.id, entity: this.requirement, method: 'DELETE'}).then(
                    function(response) {
                    	//that.edit = false;
                        that.$bus.$emit('delete-requirement', that.requirement.id);
                    },
                    function(response) {
                        
                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];
                            
                        } else {
                            
                        }
                    }

                )
            }
        }
    }
</script>